import React, { Component } from 'react';
import { List, Row, Col } from 'antd';
import './index.css'
import '../../assets/css/common.css'
import { searchAPI } from '../../api/achievement.js'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class Achievement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			total: 0,
			pageSize: 10,
			pageNum: 1,
			dataSource: [],
			loading: false,
		}
	}

	componentDidMount() {
		this.fetchData()
	}

	fetchData = () => {
		const { pageSize, pageNum } = this.state;
		this.setState({ loading: true }, () => {
			searchAPI({ page_size: pageSize, page_num: pageNum })
				.then(res => {
					console.log('ajax', res);
					this.setState({
						dataSource: res.data.data.data,
						total: res.data.data.total,
						loading: false,
					})
					document.body.scrollTop = 0; // For Safari
					document.documentElement.scrollTop = 0;
				})
		})
	}

	handlePageSizeChange = (current, pageSize) => {
		this.setState({ pageSize: pageSize, pageNum: current }, () => {
			this.fetchData()
		})
	}

	handlePageNumChange = (pageNum) => {
		this.setState({ pageNum }, () => {
			this.fetchData()
		})
	}

	render() {
		const { dataSource, total, loading } = this.state;
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{ url: '/achievement', breadcrumbName: '成果' },
				]} />
				<div className="major-heading module-title" style={{ textAlign: 'left', marginTop: 10, color: '#144db9' }}>成果展示</div>
				<div className="auxiliary-text module-subtitle">ACHIEVEMENT</div>
				<List dataSource={dataSource}
					className="list-res"
					bordered size="large"
					locale={{ emptyText: ' ' }} loading={{ tip: "数据加载中 ...", spinning: loading }}
					renderItem={(item, index) => (
						<div>
							<Row className="list" style={{ marginTop: 14, color: item.is_top ? 'red' : '#333333' }}>
								<Col span={23} className="main-text" style={{ marginLeft: -10, }}>
									<ul>
										<li>
											{item.title}
											<a target="_blank" href={item.url || item.ex_url} style={{ color: '#144db9' }}>[{item.url_text}]</a>
										</li>
									</ul>
								</Col>
							</Row>
							<Row>
								<Col className="auxiliary-text" span={23} style={{ marginLeft: 30, color: '#999999' }}>
									<div>{item.tutors}</div>
									<div>{item.authors}</div>
								</Col>
							</Row>
						</div>
					)}
					style={{ marginTop: 10, marginLeft: 10, }}
					pagination={{ showQuickJumper: true, total: total, onChange: this.handlePageNumChange, onShowSizeChange: this.handlePageSizeChange, showSizeChanger: true, }}
				/>
			</div>
		);
	}
}

export default Achievement
